import {Component, Input} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {FeatherIconsComponent} from "../../../feather-icons/feather-icons.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {TableService} from "../../../../../core/services/table.service";
import {GeneralService} from "../../../../../core/services/general.service";

@Component({
  selector: 'app-add',
  standalone: true,
  imports: [FeatherIconsComponent, FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './add.component.html',
  styleUrl: './add.component.scss'
})
export class AddComponent {
  @Input() title: string;
  @Input() data: any;
  @Input() isNew: boolean = false;
  @Input() columns: any;
  @Input() confirmAction!: (data: any) => void;

  selectOptions: { [key: string]: any[] } = {}; // Almacena las opciones de cada campo select
  formData: any = {};
  formFields: any[] = [];

  constructor(public modalServices: NgbModal, private service: TableService, private generalService: GeneralService) {
  }

  ngOnInit(): void {
    this.formFields = this.columns.filter((item: any) => item.hasOwnProperty('id') && !item['onlyTable']);
    this.formFields.forEach((field: any) => {
      if (field.type === 'select' && field.serviceConfig) {
        this.loadSelectOptions(field.id, field.serviceConfig);
      }
    });

    this.formFields.forEach(field => {
      if (field.defaultValue) {
        this.formData[field.id] = field.defaultValue;
      }
    });

    // Cargar datos iniciales si existe el objeto row
    if (this.data && this.data.row) {
      this.populateFormData(this.data.row);
    }
  }

  loadSelectOptions(fieldId: string, config: any): void {

    this.service.loadSelectOptions(config).subscribe(
        (res: any) => {
          if (res.error) {
            this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            this.selectOptions[fieldId] = [];
          } else {
            this.selectOptions[fieldId] = res['message'];
          }
          console.log(this.selectOptions[fieldId]);
        },
        (err) => {
          this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          this.selectOptions[fieldId] = [];
        }
    );
  }

  //Cargar datos de edición
  populateFormData(row: any): void {
    // Mapeamos los valores de `row` al modelo del formulario
    Object.keys(row).forEach((key) => {
      if (row[key] !== null && row[key] !== undefined) {
        this.formData[key] = row[key];
      }
    });
  }

  //Control y validación de formulario
  validateForm(): boolean {
    let isValid = true;

    // Recorre todos los campos para verificar si están completos
    for (const field of this.formFields ?? []) {
      const formControl = this.formData[field.id];

      // Validación de campos requeridos
      if (field.required) {
        // Para campos de tipo 'date', validamos si el valor es una fecha válida
        if (field.type === 'date' && !this.isValidDate(formControl)) {
          this.setErrorState(field.id, true);
          isValid = false;
        }
        // Para campos de tipo 'select', validamos si se ha seleccionado un valor
        else if (field.type === 'select' && !this.isValidSelect(formControl)) {
          this.setErrorState(field.id, true);
          isValid = false;
        }
        // Para otros tipos de campos (por ejemplo 'text'), validamos si tienen un valor
        else if (!formControl) {
          this.setErrorState(field.id, true);
          isValid = false;
        } else {
          this.setErrorState(field.id, false);
        }
      }
    }
    return isValid;
  }

  // Función para validar si es una fecha válida
  isValidDate(date: any): boolean {
    const parsedDate = Date.parse(date);
    return !isNaN(parsedDate); // Retorna true si es una fecha válida, false si no lo es
  }

  // Función para validar si un campo 'select' tiene un valor seleccionado
  isValidSelect(value: any): boolean {
    return value !== null && value !== undefined && value !== ''; // Valida que el valor no esté vacío
  }

  // Función para agregar o quitar la clase de error
  setErrorState(fieldId: string, isError: boolean): void {
    const field = document.getElementById(fieldId);
    if (field) {
      if (isError) {
        field.classList.add('is-invalid'); // Clase de error de Bootstrap
      } else {
        field.classList.remove('is-invalid'); // Elimina la clase de error
      }
    }
  }

  // Función para alternar la visibilidad de la contraseña
  togglePasswordVisibility(field: any) {
    field.showPassword = !field.showPassword;
  }

  //función para controlar booleano 0 o 1
  onBooleanChange(event: any, fieldId: string): void {
    // Asignar 1 si está marcado, 0 si está desmarcado
    this.formData[fieldId] = event.target.checked ? 1 : 0;
  }

  //Función para guardar registro
  save() {
    if (this.validateForm()) {
      console.log("Formulario enviado:", this.formData);
      this.service.addRow({action: this.data.action, formData: this.formData}).subscribe(
          (res: any) => {
            if (res.error) {
              this.generalService.showMessage('warn', 'Error ' + res.idError + '!. ' + res.message);
            } else {
              this.generalService.showMessage('success', res.message, 10000);
              if (this.confirmAction) {
                this.confirmAction(this.data); // Ejecuta la función pasada
              }
              this.modalServices.dismissAll();  // Cierra la modal
            }
          },
          (err) => {
            this.generalService.showMessage('warn', 'Error! ' + JSON.stringify(err));
          }
      );
    }
  }

  //Función para imagen
  onImageSelected(event: any, fieldId: string) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.formData[fieldId] = e.target.result; // Almacena la URL de la imagen base64
      };
      reader.readAsDataURL(file);
    }
  }
}
